__turbopack_context__.v({
  "bannerWrapper": "WoPVXW_bannerWrapper",
  "blurWrapper": "WoPVXW_blurWrapper",
  "blurred": "WoPVXW_blurred",
  "blurredInfo": "WoPVXW_blurredInfo",
  "desktopImage": "WoPVXW_desktopImage",
  "image": "WoPVXW_image",
  "link": "WoPVXW_link",
  "mobileImage": "WoPVXW_mobileImage",
  "slideWrapper": "WoPVXW_slideWrapper",
});
